import TheNavigationBar from '../components/navigation/TheNavigationBar'
import FooterNavigation from '../components/footer/footer.vue'
import { datadogRum } from '@datadog/browser-rum'

export default {
  mounted() {
    let user = JSON.parse(localStorage.getItem('USER_INFO'))

    if (user) {
      datadogRum.setUser({
        id: user.id,
        email: user.email,
        role: user.role
      })
    }
  },

  components: {
    TheNavigationBar,
    FooterNavigation
  }
}
